// Who sees the summary above the Agent Metrics grid (tiles, daily chart, Compare agents), the same way
// as the Ratings charts (CP-5220, reviewInsightsAccess.js): every operator's staff since 2026-10-29,
// when the help@ preview ended. An operator's config.features.agent_metrics_summary set to false turns
// it off for it, and then the page makes none of the summary's extra report requests (each page open
// otherwise runs three staff reports instead of one).
export function canSeeAgentMetricsSummary(tourOperator) {
    return tourOperator?.config?.features?.agent_metrics_summary !== false;
}
